import { render, staticRenderFns } from "./UpdateFaq.vue?vue&type=template&id=09f9c33a"
import script from "./UpdateFaq.vue?vue&type=script&lang=js"
export * from "./UpdateFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports